import Layout from '@components/layout/Layout'
import LocalSideNav from '@components/layout/LocalSideNav'
import DepreciationProfileNotMaintained from './DepreciationProfileNotMaintained'
import { useAssetDepreciationProfiles } from '@hooks'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { Button, Icon, Spacer } from '@common'
import { ASSET_PATHS } from '@constants'

const AssetDepreciationProfiles = () => {
  const location = useLocation()
  const isProductionUnitsRoute = location.pathname.includes(ASSET_PATHS.PRODUCTION_UNITS)
  const { assetID, companyID } = useParams()

  const {
    isLoading,
    depreciationProfileLabel,
    isProfileMaintained,
    hasUnitsOfProduction,
    sideNavItems,
  } = useAssetDepreciationProfiles()

  const CustomSideNavWithProductionUnitsBtn = () => {
    return (
      <>
        <LocalSideNav items={sideNavItems} />
        {hasUnitsOfProduction && (
          <>
            <Spacer y="default" />
            <Button
              link={`/assets/${companyID}/${assetID}/depreciation/${ASSET_PATHS.PRODUCTION_UNITS}`}
              iconRight={<Icon name="ArrowRight" />}
            >
              Set Units Produced
            </Button>
          </>
        )}
      </>
    )
  }

  if (isLoading && !isProductionUnitsRoute) return <p>Loading...</p>

  return (
    <Layout hasSidebar sidebarElement={<CustomSideNavWithProductionUnitsBtn />}>
      {isProductionUnitsRoute ? (
        <Outlet />
      ) : isProfileMaintained ? (
        <Outlet />
      ) : (
        <DepreciationProfileNotMaintained profileLabel={depreciationProfileLabel} />
      )}
    </Layout>
  )
}
export default AssetDepreciationProfiles
